// var data_main = require("./global_var");
// var riskDATA = data_main.riskData;
var data_file = String(document.getElementById('riskData').getAttribute('key'))
// Get title to use for download data
let currSurvey = data_file.split('_')[0];
var data_string = String("./data/" + data_file + '.json');
var data_aux = require("./global_var");
var hyphen_data = data_aux.hyphenData;

let hyphen_dict = {}
for (let i = 0; i < hyphen_data.length; i++) {
    hyphen_dict[hyphen_data[i].Condition] = hyphen_data[i].ConditionHyphen;
}

const {
    curr_survey,
    survey_dict
} = require("./survey_dict");

// time period object consumed by clean_data_export.js
let tObj = {
    T1: survey_dict[curr_survey].t1,
    T2: survey_dict[curr_survey].t2,
};

if(survey_dict[curr_survey].t3) {
   tObj.T3 = survey_dict[curr_survey].t3;
}

// console.log('riskData', riskDATA)
var {
    isExtraSmall,
    isSmall,
    isMedium,
    isLarge
} = require("./lib/breakpoints");
var makeTranslate = require("./lib/makeTranslate");
var debounce = require("./lib/debounce");
var classify = require("./lib/classify");
var unclassify = require("./lib/unclassify");
var formatStyle = require("./lib/formatStyle");
var export_data = require("./lib/export_data");
var saveAs = require('file-saver');
var cleanDataforExport = require('./lib/clean_data_export');

var d3 = {
    ...require("d3-axis/dist/d3-axis.min"),
    ...require("d3-scale/dist/d3-scale.min"),
    ...require("d3-selection/dist/d3-selection.min"),
    ...require("d3-shape/dist/d3-shape.min"),
    ...require("d3-collection/dist/d3-collection.min"),
    ...require("d3-format/dist/d3-format.min"),
    ...require("d3-array/dist/d3-array.min"),
    ...require("d3-textwrap/build/d3-textwrap.min"),
    ...require("d3-fetch/dist/d3-fetch")
};

//re-render chart on resize
window.addEventListener("resize", debounce(renderRiskGraphic));
//window.addEventListener("resize", renderRiskGraphic());

var line = d3.line();

function renderRiskGraphic() {

    var barHeight = 25,
        barGap = 15,
        metricLabelWidth = 85,
        labelWidth = 110,
        labelPadding = 20,
        labelMargin = 6,
        valueGap = 6;
    // num_rows = 12;

    var margins = {
        top: 40,
        right: 50,
        bottom: 20,
        left: labelWidth + labelMargin
    };

    if (isLarge.matches || (isMedium[0].matches && isMedium[1].matches)) {
        totalChartHeight = 130;
        labelPadding = 0;
        betweenChartMargin = 65;
        barWidth = 60;
        barGap = 15;
        labelWidth = 180;
        barHeight = 25;
        margins = {
            top: 40,
            right: 45,
            bottom: 20,
            left: labelWidth + labelMargin
        };
    }



    d3.json(data_string).then(function (riskDATA) {

        //console.log('data in risk', riskDATA)

        // var chart_subpop = d3.select(".riskChart").attr('subpop')
        // console.log(d3.select(".riskChart").attr('subpop'))

        //console.log('risk data filtered', dataFiltered);

        let risk_time_period;
        // determine the latest time period available
        for (var i = 1; i < 4; i++) {
            if (riskDATA[0][`Est.P.T${i}.AttRisk`]) {
                risk_time_period = i;
            }
        }
        //console.log("risk time period", risk_time_period)

        let extentColumn = `Est.P.T${risk_time_period}.Cond`,
            extentStartRange = `LCB.P.T${risk_time_period}.Cond`,
            extentEndRange = `UCB.P.T${risk_time_period}.Cond`,
            relativeColumn = `Est.Ratio.T${risk_time_period}.RelRisk`,
            relativeStartRange = `LCB.Ratio.T${risk_time_period}.RelRisk`,
            relativeEndRange = `UCB.Ratio.T${risk_time_period}.RelRisk`,
            attColumn = `Est.P.T${risk_time_period}.AttRisk`,
            attStartRange = `LCB.P.T${risk_time_period}.AttRisk`,
            attEndRange = `UCB.P.T${risk_time_period}.AttRisk`;

        // console.log("extentColumn", extentColumn)
        // console.log("extentStartRange", extentStartRange)
        // console.log("extentEndRange", extentEndRange)
        // console.log("relativeColumn", relativeColumn)
        // console.log("relativeStartRange", relativeStartRange)
        // console.log("relativeEndRange", relativeEndRange)
        // console.log("attColumn", attColumn)
        // console.log("attStartRange" , attStartRange)
        // console.log("attEndRange", attEndRange)


        var containers = document.querySelectorAll(".riskChart");
        // console.log(containers);

        //clear for redraw
        var containerElements = d3.selectAll(containers);
        containerElements.html("");

        // Calculate actual chart dimensions
        var chartWidth = containers[0].offsetWidth - margins.left - margins.right;


        containers.forEach(function (node) {

            let graphicTitle = node.closest('.chartDiv').childNodes[1].textContent;
            // let response = node.closest('.chartDiv').childNodes[1].textContent;
            // console.log("graphicTitle: ",graphicTitle);


            let response_type = node.getAttribute('key');
            // console.log('response_type', response_type);

            dataFiltered = riskDATA.filter(function (d) {
                return classify(d.ResponsePL) == response_type;
            });

            //sort the data by value
            var sortedData_1 = dataFiltered.sort((a, b) => d3.descending(Number(a[attColumn]),
                Number(b[attColumn])));

            // console.log("title: ", graphicTitle);

            //// filter data for subpop
            var chart_subpop = d3.select(node).attr('subpop').replaceAll("_", " ");

            //filter to current subpopulation
            let sortedData = sortedData_1.filter(function (d) {
                return d.SubpopPL == chart_subpop;
            });

            // filter data to only show point estimates for attributable risk greater than zero
            sortedData = sortedData.filter(function (d) {
                return d[attColumn] > '0';
            });
            
            // console.log('sortedData', sortedData);

            //reassign num
            let num_rows = sortedData.length;
            let chartHeight = (barHeight + barGap) * num_rows;

            //console.log(sortedData);
            ///prepare data for export

            var dataForExport = JSON.parse(JSON.stringify(sortedData));

            var response = unclassify(response_type);
            // console.log(response);

            dataForExport = cleanDataforExport(dataForExport, 'risk', response, [risk_time_period], tObj);

            
            var chart_link = d3.select(node.closest('.chartDiv')).select('.riskAnnotation').empty() ? node.nextElementSibling :
            node.nextElementSibling.nextElementSibling;
            
            let response_for_download = response === "Vegetation Mmi" ? "Vegetation MMI" : response;

            // download link
            d3.select(chart_link)
            .selectAll("a.downloadLink")
            .on('mouseover', (d) => {
                d3.select(chart_link).select('a.downloadLink')
                .attr('href', `${currSurvey}_Attributable-Risk-to-` +
                response_for_download.replace(" ", "-") +
                "-Estimates_" + chart_subpop + ".csv")  //this adds an address that will appear in the lower left corner on Chrome
                .attr('title', "") // this removes the "Data Download" tooltip on hover
            })
            .on('mouseout', (d) => {
                d3.select(chart_link).select('a.downloadLink')
                .attr('title', "Data Download"); // this replaces the "Data Download" title after hover
            })
            .on('click', (d) => {
                    var csv_blob = export_data(dataForExport, graphicTitle, response_type, null, null, "risk");
                    var link = node.nextElementSibling;
                    d3.select(chart_link).select('a.downloadLink')
                        .attr('href', null)
                        .style('color', '#5f4c95') //prevent reload on click

                    let downloadTitle = survey_dict[curr_survey]["riskDownloadTitle"].replace("Response", response_for_download).replace("chartSubpop", chart_subpop);
                    downloadTitle = downloadTitle.replace(/ /g, "-");
                    saveAs(csv_blob, downloadTitle + ".csv");
                });

            // dashboard link
            d3.select(chart_link)
            .selectAll("a.dashboardLink")
            .on('mouseover', () => {
                d3.select(chart_link)
                .select('a.dashboardLink')
                .attr('title', ""); // this removes the "Dashboard Link" tooltip on hover
            })
            .on('mouseout', () => {
                d3.select(chart_link)
                .select('a.dashboardLink')
                .attr('title', "Dashboard Link"); // this replaces the "Dashboard Link" title after hover
            })
        
            ///draw charts
            chart_type = node.id;

            var chartDiv = d3.select(node)
                .append('div')
                .attr('class', 'graphic-wrapper');

            var chartElements = chartDiv
                .append("svg")
                .attr("width", chartWidth + margins.left + margins.right)
                .attr("height", chartHeight + margins.top + margins.bottom)
                .attr("overflow", "visible")
                .append("g")
                .attr("transform", `translate(${margins.left},${margins.top})`);

            if (chart_type == 'relative-risk-chart') {

                // find max UCI
                var uci = [];
                sortedData.forEach(function (d) {
                    if (d[relativeEndRange] != 'NA') {
                        uci.push(Math.ceil(Number(d[relativeEndRange])));
                    }
                });
                max_val = Math.max(...uci);

                var xScale = d3
                    .scaleLinear()
                    .domain([0, max_val])
                    .range([0, chartWidth]);

                // Create D3 axes.
                var xAxis = d3.axisTop(xScale)
                    .ticks(5);

            } else {
                var xScale = d3
                    .scaleLinear()
                    .domain([0, 100])
                    .range([0, chartWidth]);

                // Create D3 axes.
                var xAxis = d3.axisTop(xScale)
                    .ticks(5)
                    .tickFormat(d => d + "%");
            }

            // Render axes to chart.
            chartElements
                .append("g")
                .attr("class", "x axis")
                .call(xAxis);

            // Render grid to chart.
            var xAxisGrid = function () {
                return xAxis;
            };

            chartElements
                .append("g")
                .attr("class", "x grid")
                .call(
                    xAxisGrid()
                    .tickSize(-chartHeight, 0, 0)
                    .tickFormat("")
                );
            let y = d3.scaleBand()
                .domain(d3.range(sortedData.length))
                .rangeRound([0, chartHeight + barGap / 2])
                .padding(0.1);

            let yAxis = g => g
                .call(d3.axisLeft(y).tickFormat(i => {
                        var value = sortedData[i].StressorPL;
                        if (value == 'Chlorophyll a') {
                            return "Chlorophyll <span class = 'italic'>a</span>";
                        } else if (isLarge.matches && value != 'Chlorophyll a') {
                            return value;
                        } else if (!isLarge.matches && value != 'Chlorophyll a') {
                            //the hyphen dictionary isn't used here because none of the indicators have hyphens listed.
                            return value; 
                        }
                    })
                    .tickSizeOuter(0)
                    .tickSize(0))
                .call(g => g.select(".domain").remove());

            chartElements.append("g")
                .attr("class", "y-axis")
                .call(yAxis);
            // metricSections = chartElements.selectAll('.metricSection')
            // .data(sortedData)
            // .enter()
            // .append('g')
            // .attr('class', 'metricSection')
            // .attr('id', d => d.key)
            // .attr('height', d => d.values.length *(barHeight + barGap));


            // // console.log('node', node)
            // // console.log('this', this.node)

            // nodes = d3.selectAll("#"+chart_type+" g.metricSection");

            //  nodes.each(function(d,i){

            var num_indicators = sortedData.length,
                valueColumn;

            switch (chart_type) {
                case 'relative-risk-chart':
                    valueColumn = relativeColumn;
                    startColumn = relativeStartRange;
                    endColumn = relativeEndRange;
                    break;
                case 'relative-extent-chart':
                    valueColumn = extentColumn;
                    startColumn = extentStartRange;
                    endColumn = extentEndRange;
                    break;
                case 'attributable-risk-chart':
                    valueColumn = attColumn;
                    startColumn = attStartRange;
                    endColumn = attEndRange;
            }

            var chartArea = chartElements.append('g')
                // .attr('transform', d =>{
                //   if (i==1){
                //   return 'translate(0, ' + translate_value + ')';
                //   }})
                .attr('class', 'chartAreag');

            var barArea = chartArea.append('g')
                .attr('class', 'barAreag');


            bars = barArea.selectAll('rect')
                .data(sortedData)
                .enter();

            bars
                .append('rect')
                .attr('class', d => 'bar ' + chart_type + ' ' + classify(d.StressorPL))
                .attr("x", d => {
                    // console.log('d in x ', d, d[valueColumn])
                    return d[valueColumn] >= 0 ? xScale(0) : xScale(d[valueColumn]);
                })
                .attr("y", (d, i) => i * (barHeight + barGap) + barHeight * 0.5)
                .attr("height", barHeight)
                .attr("width", d => {
                    if (d[valueColumn] != 'NA' && !isNaN(d[valueColumn]) && d[valueColumn] >= 0) {
                        return Math.abs(xScale(0) - xScale(d[valueColumn]));
                    }
                });

            //range
            bars
                .append('rect')
                .attr('class', d => 'range ' + chart_type + ' ' + classify(d.StressorPL))
                .attr('x', d => d[startColumn] < 0 ? xScale(0) : xScale(d[startColumn]))
                .attr('y', (d, i) => i * (barHeight + barGap) + barHeight - 2)//the -2 centers in the middle of the bar
                .attr('height', barHeight / 11)
                .attr('width', d => {
                    // console.log('end', xScale(d[endColumn]), 'start', xScale(d[startColumn]))
                    // console.log(chart_type, d.StressorPL);
                    //  console.log('-----------')
                    //  console.log(Math.abs(xScale(d[endColumn]-d[startColumn])))
                    if (d[endColumn] - d[startColumn]) {
                        if (d[startColumn] < 0) {
                            return xScale(d[endColumn]);
                        } else {
                            return xScale(d[endColumn] - d[startColumn]);
                        }
                    } else {
                        return 0;
                    }
                });

            //add bar values
            bars.append('g')
                .attr('class', 'value')
                .append('text')
                .attr('class', d => {
                    if (d[valueColumn] == 'NA' || d[endColumn] == 'NA' || d[startColumn] == 'NA' || d[valueColumn] == 0) {
                        return 'na ' + 'labels risk ' + chart_type;
                    } else {
                        return 'labels risk ' + chart_type;
                    }
                })
                .attr('id', d => classify(d.StressorPL))
                .attr('y', (d, i) => i * (barHeight + barGap) + barHeight * 1.1)
                .attr('x', d => d[endColumn] == 'NA' ? 0 : xScale(d[endColumn]) + 5)

                .text(d => {
                    // console.log('d', chart_type, d.StressorPL, d);

                    switch (chart_type) {
                        case 'relative-extent-chart':
                            return Math.round(d[valueColumn]) + '%';
                        case 'relative-risk-chart':
                            if (d[valueColumn] == 0) {
                                return 'None';
                            } else if (d[valueColumn] == 'NA' || d[endColumn] == 'NA' || d[startColumn] == 'NA') {
                                return 'N/A';
                            } else {
                                return Number(d[valueColumn]).toFixed(1);
                            }
                            break;
                        case 'attributable-risk-chart':
                            if (d[valueColumn] == 'NA' || d[endColumn] == 'NA' || d[startColumn] == 'NA') {
                                return 'N/A';
                            } else if (d[valueColumn] == 0) {
                                return 'None';
                            } else {
                                if (d[valueColumn] > 0 && d[valueColumn] < 0.5) {
                                    return "<1%";
                                } else {
                                    return Math.round(d[valueColumn]) + '%';
                                }
                            }
                            break;
                    }
                });


            //////add annotations//////////
            if (!d3.select(node.closest('.chartDiv')).select('.riskAnnotation').empty()) {
                key = d3.select(node.closest('.chartDiv')).select('.riskAnnotation').attr('key');
                annotation_text = d3.select(node.closest('.chartDiv')).select('.riskAnnotation').select('p').node()
                replaceDataValue(annotation_text, key, valueColumn, response_type, riskDATA, risk_time_period);

                //add arrow marker
                chartElements.append("defs").html(`<marker id="arrow" viewBox="0 0 10 10" refX="5" refY="5"
            markerWidth="6" markerHeight="6"
            orient="auto-start-reverse">
          <path fill="#58595B" d="M 0 0 L 10 5 L 0 10 z" />
        </marker>`);


                id = d3.select(node.closest('.chartDiv')).select('.riskAnnotation').attr('id');

                chartElements
                    .append('g')
                    .attr('class', 'risk_anno_line')
                    .attr('id', id)
                    .append('path')
                    .attr('shape-rendering', 'crispEdges')
                    .attr('d', d => {
                        var lineCoords = [];
                        var target = d3.select(node).select(`.labels#${id}`);
                        var targetCoords = [Number(target.attr("x")) + target.node().getComputedTextLength() + 10, Number(target.attr("y")) - 5];
                        var targetGroup = d3.select(node.closest(".chartDiv")).selectAll(`text.labels`);
                        var targetIndex = targetGroup.data().findIndex(bar => classify(bar.StressorPL) == id);
                        var belowIndex = targetGroup.filter((d, i) => i >= targetIndex);

                        var belowValues = [];
                        belowIndex.each(function (d, i) {
                            var x = Number(d3.select(this).attr("x"));
                            var dx = Number(d3.select(this).attr("dx"));
                            var textWidth = this.getComputedTextLength();
                            var rightX = x + textWidth + dx;
                            if (!isNaN(rightX)) {
                                belowValues.push(rightX);
                            }
                        });

                        var maxX = Math.max(...belowValues);
                        var intermediateX = maxX + 15;

                        var intermediateCoords = [intermediateX, targetCoords[1]];
                        var endCoords = [intermediateCoords[0], chartHeight + margins.bottom];

                        lineCoords.push(endCoords, intermediateCoords, targetCoords);
                        return line(lineCoords);
                    })
                    .attr("class", "annotationLine")
                    .attr("marker-end", "url(#arrow)");
            }

            // Get the current information in order to update the title/tooltip.
            const year =  node.previousElementSibling.previousElementSibling.innerText.match(/\(([^()]*)\)$/)[1];
            let response_for_title = response == "Vegetation Mmi" ? "Vegetation MMI" : response;
            node.setAttribute(
                "title",
                `Bar graph showing attributable risk for stressors measured during 2016, in relation to ${response_for_title} and in order by magnitude, for the ${chart_subpop} subpopulation. Bars are only shown for point estimates greater than zero.`
            );
            node.setAttribute(
                "alt", 
                `Graph of ${year} attributable risk calculated using ${response_for_title} as an indicator of biological condition.`
            );

        });

        let wrap = d3.textwrap().bounds({
            width: labelWidth,
            height: barHeight + labelPadding * 3
        });

        d3.selectAll('.riskChart .y-axis .tick text').call(wrap);

        d3.selectAll('.riskChart foreignObject')
            .style('transform', 'translate(-' + (labelWidth + 5) + 'px, -' + (barHeight + labelPadding * 3) / 2.0 + 'px)')
            .style('text-align', 'right');

        d3.selectAll('.riskChart .y-axis .tick foreignObject div')
            .style('width', labelWidth + 'px')
            .style('height', barHeight + labelPadding * 3 + 'px')
            .style('display', 'table-cell')
            .style('vertical-align', 'middle')
            .style('line-height', d => {
                if (isLarge.matches || (isMedium[0].matches && isMedium[1].matches)) {
                    return barHeight + labelPadding * 3 + "px";
                }
            });
    });
}

renderRiskGraphic();

function replaceDataValue(element, stressor, valueColumn, response_type, riskDATA, risk_time_period) {
    var dataValue = riskDATA.filter(r => r.StressorPL == stressor &&
        classify(r.ResponsePL) == response_type)[0];
    if (dataValue) {
        d3.select(element).select("span.dataValue")
            .html(function (d) {
                if (valueColumn == `Est.Ratio.T${risk_time_period}.RelRisk`) {
                    return `${Number(dataValue[valueColumn]).toFixed(1)}`;
                } else {
                    return `${Number(dataValue[valueColumn]).toFixed(0)}%`;
                }
            });
    }
}